module.exports = __webpack_public_path__ + "img/second-comparison2.a00a22d1.gif";